export default __webpack_public_path__ + "static/media/SF-Pro-Rounded-Medium.b15932ba.otf";